exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModalWindow {\n    z-index: 99999;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    background-color: rgba(33, 37, 41, 0.2);\n    display: flex;\n}\n\n    .ModalWindow__content {\n        margin: auto;\n    }\n\n    .ModalWindow-withTransitions {\n        transition: all 0.3s ease-in;\n        opacity: 0;\n    }\n\n    .ModalWindow-fadeIn {\n        opacity: 1;\n    }\n\n    .ModalWindow-fadeOut {\n        opacity: 0;\n    }", ""]);

// exports
